"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stringifyStream = require("stream-to-string");
/**
 * A comunica-based GraphQL-LD query engine.
 */
class GraphQlQueryEngine {
    constructor(comunicaEngine) {
        this.comunicaEngine = comunicaEngine;
    }
    async query(query, options) {
        const { data } = await this.comunicaEngine.resultToString(await this.comunicaEngine.query(query, options), 'application/sparql-results+json');
        return JSON.parse(await stringifyStream(data));
    }
}
exports.GraphQlQueryEngine = GraphQlQueryEngine;
//# sourceMappingURL=GraphQlQueryEngine.js.map